import React from 'react';

import {
  Landing,
  Result,
  ReviewAnswer,
  Session,
  SessionRoute,
  SolutionRoute,
  SolutionList,
  SolutionDetail,
  GradedExamResult,
  OfficialExamResult,
} from './SubRoutes';

export const QUIZ_VARIANTS = {
  OFFICIAL_EXAM: 'Official Exam',
  GRADED_EXAM: 'Graded Exam',
  DEFAULT: 'Default',
};

export const QUIZ_SUB_ROUTES = {
  LANDING: {
    path: '/exams/:examId',
    component: (props) => <Landing {...props} />,
    exact: true,
    getPath: (examId) => {
      return `/exams/${examId}`;
    },
  },
  RESULT: {
    path: '/exams/:examId/exam-sessions/:examSessionId/result',
    component: (props) => <Result {...props} />,
    exact: true,
    getPath: (examId, examSessionId) => {
      return `/exams/${examId}/exam-sessions/${examSessionId}/result`;
    },
  },
  GRADED_EXAM_RESULT: {
    path: '/exams/:examId/graded-exam-sessions/:examSessionId/result',
    component: (props) => <GradedExamResult {...props} />,
    exact: true,
    getPath: (examId, examSessionId) => {
      return `/exams/${examId}/graded-exam-sessions/${examSessionId}/result`;
    },
  },
  OFFICIAL_EXAM_RESULT: {
    path: '/exams/:examId/official-exam-sessions/:examSessionId/result',
    component: (props) => <OfficialExamResult {...props} />,
    exact: true,
    getPath: (examId, examSessionId) => {
      return `/exams/${examId}/official-exam-sessions/${examSessionId}/result`;
    },
  },
  SOLUTION: {
    path: '/exams/:examId/exam-sessions/:examSessionId/solutions',
    component: (props) => <SolutionRoute {...props} />,
    exact: false,
    getPath: (examId, examSessionId, roundIndex) => {
      return `/exams/${examId}/exam-sessions/${examSessionId}/solutions?roundIndex=${roundIndex}`;
    },
  },
  SESSION: {
    path: '/exams/:examId/exam-sessions/:examSessionId',
    component: (props) => <SessionRoute {...props} />,
    exact: false,
    getPath: (examId, examSessionId) => {
      return `/exams/${examId}/exam-sessions/${examSessionId}`;
    },
  },
};

export const SESSION_SUB_ROUTES = {
  SESSION: {
    path: '/exams/:examId/exam-sessions/:examSessionId/session',
    component: (props) => <Session {...props} />,
    exact: true,
    getPath: (examId, examSessionId) => {
      return `/exams/${examId}/exam-sessions/${examSessionId}/session`;
    },
  },
  REVIEW_ANSWER: {
    path: '/exams/:examId/exam-sessions/:examSessionId/review-answer',
    component: (props) => <ReviewAnswer {...props} />,
    exact: true,
    getPath: (examId, examSessionId) => {
      return `/exams/${examId}/exam-sessions/${examSessionId}/review-answer`;
    },
  },
};

export const SOLUTION_SUB_ROUTES = {
  SOLUTION_LIST: {
    path: '/exams/:examId/exam-sessions/:examSessionId/solutions',
    component: (props) => <SolutionList {...props} />,
    exact: true,
    getPath: (examId, examSessionId, roundIndex) => {
      return `/exams/${examId}/exam-sessions/${examSessionId}/solutions?roundIndex=${roundIndex}`;
    },
  },
  SOLUTION_DETAIL: {
    path: '/exams/:examId/exam-sessions/:examSessionId/solutions/:examPaperItemId',
    component: (props) => <SolutionDetail {...props} />,
    exact: true,
    getPath: (examId, examSessionId, examPaperItemId) => {
      return `/exams/${examId}/exam-sessions/${examSessionId}/solutions/${examPaperItemId}`;
    },
  },
};

export const EXAM_PAPER_ITEM_TYPE = {
  MULTIPLE_CHOICE: 'MULTIPLE_CHOICE',
  MULTIPLE_CHOICE_DIFFERENT_SCORE: 'MULTIPLE_CHOICE_DIFFERENT_SCORE',
  MULTIPLE_SELECT: 'MULTIPLE_SELECT',
  MULTIPLE_SELECT_WITH_CORRECT_ANSWERS: 'MULTIPLE_SELECT_WITH_CORRECT_ANSWERS',
  FILL_NUMBER: 'FILL_NUMBER',
  CONNECTION: 'CONNECTION',
};
